export default class Switcher {
	constructor() {
		document.addEventListener("click", function (event) {
			if (!event.target.classList.contains("switcher__lang__current")) {
				return;
			}

			var content = document.querySelector(event.target.hash);
			document.body.classList.add("nav-hide");
			content.classList.toggle("show");
			event.preventDefault();
		});
	}
}
